import { Expose, Type } from 'class-transformer';
import { ResourceBuildingDto } from '../../../room/dto/response/resource-building.dto';

export class CreditBalanceCreditDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'credit_type_id' })
  creditTypeId: number;
  @Expose({ name: 'company_id' })
  companyId: number;
  @Expose({ name: 'user_id' })
  userId: number;
  @Expose({ name: 'is_repeat' })
  isRepeat: boolean;
  @Expose({ name: 'repeat_type' })
  repeatType: string;
  @Expose({ name: 'amount' })
  amount: number;
  @Expose({ name: 'start_Date' })
  startDate: string;
  @Expose({ name: 'end_date' })
  endDate: string;
}
